// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"cb498362","725":"86d021b7","855":"cc5813e1","976":"bb18862b"}[chunkId] + ".chunk.js";
};